/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import ServicePath from "@/core/ServicePath";
import MainService from "@/app/services/MainService";

export default class InterpretationService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.INTERPRETATIONPENDING_LISTALL_PAGINATION, params);
  }
  static getImagebyStudy(params){
    return this.postSEC(ServicePath.STUDY_FIND_ALL_IMAGES_BY_STUDY, params);
  } 
  static get(params) {
    return this.postSEC(ServicePath.STUDY_BY_ID, params)
  }

  static getColposcopyForm(params) {
    return this.postSEC(ServiceConstant.COLPOSCOPY_GET, params)
  }

  static saveColposcopyFormInterpretation(params) {
    return this.postSEC(ServicePath.INTERPRETATION_SAVE_FORM, params)
  }

  static saveColposcopyFormInterpretationFiles(params) {
    return this.postSEC(ServicePath.INTERPRETATION_SAVE_FILES, params)
  }
  // static get(params) {
  //   return this.postSEC(ServiceConstant.MASTOGRAPHYFINDING_GET, params);
  // }
  static add(params) {
    return this.postSEC(ServicePath.INTERPRETATION_SAVE, params);
  }
  
  static validateStudyToInterpret(idStudy) {
    return this.postSEC(ServiceConstant.INTERPRETATION_VALIDATE_TO_INTERPRET, {idStudy: idStudy});
  }
  
  static resetStatusInterpreting(idStudy) {
    return this.postSEC(ServiceConstant.INTERPRETATION_RESET_STATUS_INTERPRETING, {idStudy: idStudy});
  }
  
  static unlockStudy(idStudy) {
    return this.postSEC(ServiceConstant.UNLOCKING_INTERPRETATION, {idStudy: idStudy});
  }


}
